export const matterOverviewSections = [
  "Basic Information",
  "Parties",
  "Relationship Details",
  "Court Details",
] as const;

export type MatterOverviewSection = (typeof matterOverviewSections)[number];
